// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActiveState } from "./active-state";
import { PreconditionUnknown } from "./precondition-unknown";
import { SequenceStepScope } from "./sequence-step-scope";
import { StepPositionSource } from "./step-position-source";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Added v8 — a condition on a channel's current state.
 *
 * Checked when the modifier fires. Every precondition must hold for the
 * modifier to act; when one does not, the source command passes through as if
 * the modifier did not exist.
 */
export class ModifierStateCondition implements flatbuffers.IUnpackableObject<ModifierStateConditionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifierStateCondition {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsModifierStateCondition(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifierStateCondition,
  ): ModifierStateCondition {
    return (obj || new ModifierStateCondition()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsModifierStateCondition(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifierStateCondition,
  ): ModifierStateCondition {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ModifierStateCondition()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * The channel whose last reported state is read. Must be on the same
   * server as the modifier's source channel.
   */
  channelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * The (content, value) leaf to read, as for an expected step.
   */
  messageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * The level the leaf must have now: `ACTIVE` or `INACTIVE`. `UNSET` is
   * rejected.
   */
  expectedActive(): ActiveState {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActiveState.UNSET;
  }

  /**
   * Which floor the leaf is read at. See `StepPositionSource`.
   */
  positionSource(): StepPositionSource {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : StepPositionSource.PAYLOAD;
  }

  /**
   * How positions and lifts must agree, as for an expected step.
   */
  scope(): SequenceStepScope {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SequenceStepScope.SAME_POSITION;
  }

  /**
   * What to do while the channel has not reported the leaf yet.
   */
  ifUnknown(): PreconditionUnknown {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : PreconditionUnknown.ASSUME_MET;
  }

  static startModifierStateCondition(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addChannelId(builder: flatbuffers.Builder, channelIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, channelIdOffset, 0);
  }

  static addMessageContent(builder: flatbuffers.Builder, messageContent: number) {
    builder.addFieldInt16(1, messageContent, 0);
  }

  static addMessageValue(builder: flatbuffers.Builder, messageValue: number) {
    builder.addFieldInt32(2, messageValue, 0);
  }

  static addExpectedActive(builder: flatbuffers.Builder, expectedActive: ActiveState) {
    builder.addFieldInt8(3, expectedActive, ActiveState.UNSET);
  }

  static addPositionSource(builder: flatbuffers.Builder, positionSource: StepPositionSource) {
    builder.addFieldInt8(4, positionSource, StepPositionSource.PAYLOAD);
  }

  static addScope(builder: flatbuffers.Builder, scope: SequenceStepScope) {
    builder.addFieldInt8(5, scope, SequenceStepScope.SAME_POSITION);
  }

  static addIfUnknown(builder: flatbuffers.Builder, ifUnknown: PreconditionUnknown) {
    builder.addFieldInt8(6, ifUnknown, PreconditionUnknown.ASSUME_MET);
  }

  static endModifierStateCondition(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // channel_id
    return offset;
  }

  static createModifierStateCondition(
    builder: flatbuffers.Builder,
    channelIdOffset: flatbuffers.Offset,
    messageContent: number,
    messageValue: number,
    expectedActive: ActiveState,
    positionSource: StepPositionSource,
    scope: SequenceStepScope,
    ifUnknown: PreconditionUnknown,
  ): flatbuffers.Offset {
    ModifierStateCondition.startModifierStateCondition(builder);
    ModifierStateCondition.addChannelId(builder, channelIdOffset);
    ModifierStateCondition.addMessageContent(builder, messageContent);
    ModifierStateCondition.addMessageValue(builder, messageValue);
    ModifierStateCondition.addExpectedActive(builder, expectedActive);
    ModifierStateCondition.addPositionSource(builder, positionSource);
    ModifierStateCondition.addScope(builder, scope);
    ModifierStateCondition.addIfUnknown(builder, ifUnknown);
    return ModifierStateCondition.endModifierStateCondition(builder);
  }

  unpack(): ModifierStateConditionT {
    return new ModifierStateConditionT(
      this.channelId() !== null ? this.channelId()!.unpack() : null,
      this.messageContent(),
      this.messageValue(),
      this.expectedActive(),
      this.positionSource(),
      this.scope(),
      this.ifUnknown(),
    );
  }

  unpackTo(_o: ModifierStateConditionT): void {
    _o.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    _o.messageContent = this.messageContent();
    _o.messageValue = this.messageValue();
    _o.expectedActive = this.expectedActive();
    _o.positionSource = this.positionSource();
    _o.scope = this.scope();
    _o.ifUnknown = this.ifUnknown();
  }

  unpackFields(...fields: string[]): ModifierStateConditionT {
    const t = new ModifierStateConditionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("channel_id")) {
      t.channelId = this.channelId() !== null ? this.channelId()!.unpack() : null;
    }
    if (fieldSet.has("message_content")) {
      t.messageContent = this.messageContent();
    }
    if (fieldSet.has("message_value")) {
      t.messageValue = this.messageValue();
    }
    if (fieldSet.has("expected_active")) {
      t.expectedActive = this.expectedActive();
    }
    if (fieldSet.has("position_source")) {
      t.positionSource = this.positionSource();
    }
    if (fieldSet.has("scope")) {
      t.scope = this.scope();
    }
    if (fieldSet.has("if_unknown")) {
      t.ifUnknown = this.ifUnknown();
    }
    return t;
  }
}

export class ModifierStateConditionT implements flatbuffers.IGeneratedObject {
  constructor(
    public channelId: UuidT | null = null,
    public messageContent: number = 0,
    public messageValue: number = 0,
    public expectedActive: ActiveState = ActiveState.UNSET,
    public positionSource: StepPositionSource = StepPositionSource.PAYLOAD,
    public scope: SequenceStepScope = SequenceStepScope.SAME_POSITION,
    public ifUnknown: PreconditionUnknown = PreconditionUnknown.ASSUME_MET,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.channelId === null || this.channelId === undefined) {
      throw new Error('Required field "channel_id" is not set');
    }
    const channelId = this.channelId !== null ? this.channelId!.pack(builder) : 0;

    return ModifierStateCondition.createModifierStateCondition(
      builder,
      channelId,
      this.messageContent,
      this.messageValue,
      this.expectedActive,
      this.positionSource,
      this.scope,
      this.ifUnknown,
    );
  }

  clone(): ModifierStateConditionT {
    const obj = new ModifierStateConditionT();
    obj.channelId = this.channelId !== null ? this.channelId!.clone() : null;
    obj.messageContent = this.messageContent;
    obj.messageValue = this.messageValue;
    obj.expectedActive = this.expectedActive;
    obj.positionSource = this.positionSource;
    obj.scope = this.scope;
    obj.ifUnknown = this.ifUnknown;
    return obj;
  }

  equals(other: ModifierStateConditionT): boolean {
    if (this.channelId !== null && other.channelId !== null) {
      if (!this.channelId!.equals(other.channelId!)) return false;
    } else if (this.channelId !== other.channelId) return false;
    if (this.messageContent !== other.messageContent) return false;
    if (this.messageValue !== other.messageValue) return false;
    if (this.expectedActive !== other.expectedActive) return false;
    if (this.positionSource !== other.positionSource) return false;
    if (this.scope !== other.scope) return false;
    if (this.ifUnknown !== other.ifUnknown) return false;
    return true;
  }
}

export function verifyModifierStateCondition(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "channel_id");
    verifier.checkScalarField(tablePos, 6, 2);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
  } finally {
    verifier.popDepth();
  }
}
